
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    export class PoCreditNoteDtGrid extends Serenity.EntityGrid<PoCreditNoteDtRow, any> {
        protected getColumnsKey() { return PoCreditNoteDtColumns.columnsKey; }
        protected getDialogType() { return PoCreditNoteDtDialog; }
        protected getIdProperty() { return PoCreditNoteDtRow.idProperty; }
        protected getInsertPermission() { return PoCreditNoteDtRow.insertPermission; }
        protected getLocalTextPrefix() { return PoCreditNoteDtRow.localTextPrefix; }
        protected getService() { return PoCreditNoteDtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}